<template>
  <!-- eslint-disable -->
  <div>
    <roles-add :is-add.sync="isAdd" ref="rolesAdd"> </roles-add>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="3" class="mb-md-0 mb-2">
            <!-- @input="(val) => $emit('update:roleFilter', val)" -->
            <label>Nombre</label>
            <b-form-input v-model="name" placeholder="Nombre" @input="filter"/>
          </b-col>
          <b-col md="6" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>

          <b-col class="d-flex align-items-center justify-content-end">
            <!-- @click="isAddNewUserSidebarActive = true"< -->
            <b-button variant="primary" class="mb-md-0 mb-2 mt-2" @click="addRole">
              <span class="text-nowrap">Agregar elemento</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import rolesAdd from './rolesAdd.vue'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      isAdd: false,
      isUpdate: false,
      name: '',
      arrayFilters: [],
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    rolesAdd
  },
  mounted() {
  },
  methods: {
    addRole(){
      this.isAdd = true
      this.$refs.rolesAdd.getData({})
    },
    async filter() {
      this.arrayFilters = [];
      if (this.name !== '') {
        this.arrayFilters.push({
          keyContains: 'name',
          key: 'contains',
          value: this.name
        });
      }
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.name = '';
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>